import "../style/header.scss";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Hamburger from 'hamburger-react';
import axios from "axios";
import Switch, { SwitchProps } from '@mui/material/Switch';
import {
  Drawer,
  Box,
  useTheme,
  Button
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { DRAWER_NO_SLIDE } from "./DrawerHeader";

// Hoisté pour ne pas resérialiser le style du Paper à chaque render.
const NAV_PAPER_PROPS = { sx: { width: "350px", padding: "16px" } };

function Header({ role, isAdmin, onLogout, onRoleSwitch, toggleDarkMode }) {
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const theme = useTheme();

  const handlePasswordRedirection = () => {
      navigate("/changepassword");
  };

  const handleCreateRedirection = () => {
      navigate("/createuser");
  };

  const handleChangeEnv = async (newViewRole) => {
    try {
      const token = sessionStorage.getItem('token');
      const url = process.env.REACT_APP_DOMAIN_URL + '/api/switch-view-role';

      const response = await axios.post(
        url,
        { newViewRole },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Appeler la fonction de App.js pour mettre à jour le state et revérifier isAdmin
      if (onRoleSwitch) {
        onRoleSwitch(response.data.token, response.data.viewRole);
      }

      // Forcer un hard reload pour vider le cache et recharger avec le nouveau token
      window.location.reload();
    } catch (error) {
      console.error('Erreur lors du changement de vue:', error);
      alert('Impossible de changer de vue. Veuillez réessayer.');
    }
  };

  const handleDownload = async () => {
  try {
    const url = process.env.REACT_APP_DOMAIN_URL + "/download-zip";
    const token = sessionStorage.getItem("token");

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });

    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = urlBlob;
    link.setAttribute("download", "nm-identity-card.zip");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(urlBlob);
  } catch (error) {
    console.error(
      "Erreur lors du téléchargement du fichier ZIP depuis le backend:",
      error
    );
  }
};

  const handleCloseDrawer = () => setOpen(null);

  const getLogoSrc = () => {
    const isDark = theme.palette.mode === "dark";
    switch(role){
      case('onet'):
        return isDark ? '/assets/logo-onet-blanc.png' : '/assets/Logo_Onet.svg.png';
        break;
      case('admin'):
        return '/assets/kairos.png';
        break;
      case('compass'):
        return isDark ? '/assets/CPG.L_BIG.D.png' : '/assets/CPG.L_BIG.png';
        break;
      default:
    }
    };

  return (
  <Box className="mainBox" sx={{ width: "100%", paddingTop: 0, paddingLeft:1, paddingBottom:0, paddingRight:0}}>
    <Box className="mainBox__btn" sx={{ mb: 1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
    <div className="boxHeader">
        <a href="/dashboard">
        <Box
          component="img"
          src={getLogoSrc()}
          alt="logo"
          className={role !== 'admin' ? 'no-border-radius' : ''}
          sx={{
            maxHeight: 120,
            width: 'auto',
            objectFit: 'contain',
          }}
        />
      </a>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '5px' }}>
        <Switch sx={{
                    width: 70,
                    height: 36,
                    padding: 0,
                    '& .MuiSwitch-switchBase': {
                      padding: 0,
                      margin: '2px',
                      transitionDuration: '300ms',
                      '&.Mui-checked': {
                        transform: 'translateX(34px)',
                        color: '#fff',
                        '& .MuiSwitch-thumb:before': {
                          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                            '#fff',
                          )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
                        },
                        '& + .MuiSwitch-track': {
                          opacity: 1,
                          backgroundColor: '#aab4be',
                        },
                      },
                    },
                    '& .MuiSwitch-thumb': {
                      backgroundColor: '#1e1e1e',
                      width: 32,
                      height: 32,
                      '&::before': {
                        content: "''",
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        left: 0,
                        top: 0,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                          '#fff',
                        )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
                      },
                    },
                    '& .MuiSwitch-track': {
                      opacity: 1,
                      backgroundColor: '#aab4be',
                      borderRadius: 20,
                    },
                  }}
          onClick={toggleDarkMode}
          />

        <div className="boxHeader__hamburger">
          <Hamburger
            direction="right"
            toggled={isOpen}
            toggle={setOpen}
            size={30}
            color={theme.palette.mode === 'dark' ? '#ffffff' : '#000000'}
          />
        </div>
      </div>
      <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleCloseDrawer}
      PaperProps={NAV_PAPER_PROPS}
      SlideProps={DRAWER_NO_SLIDE}
      // Sans ça, le scroll lock de MUI pose overflow:hidden + padding-right sur
      // <body> à l'ouverture, ce qui relayoute tout le dashboard pendant l'animation.
      disableScrollLock
    >
        <div className="drawerButtons">
          <Button
            className={`changepasswd ${role}`}
            onClick={handlePasswordRedirection}
            variant="contained"
            fullWidth
          >
            Changer de mot de passe
          </Button>

          {role === "admin" && (
            <Button
              className="normal"
              onClick={handleCreateRedirection}
              variant="contained"
              fullWidth
            >
              Créer un utilisateur
            </Button>
          )}

          {isAdmin && window.location.pathname  !== "/createuser" && (
            <div className="submenu">
            <Button
              className="normal submenuToggle"
              variant="contained"
              fullWidth
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                justifyContent: "center"
              }}
            >
              Choisir son rôle <KeyboardArrowDown />
            </Button>
            <div className="submenuItems">
                <Button onClick={() => handleChangeEnv("onet")} variant="outlined" fullWidth>Onet</Button>
                <Button onClick={() => handleChangeEnv("compass")} variant="outlined" fullWidth>Compass</Button>
                <Button onClick={() => handleChangeEnv("admin")} variant="outlined" fullWidth>Kairos</Button>
              </div>
            </div>
          )}

          {role === "admin" && (
            <Button
              className="normal"
              onClick={handleDownload}
              variant="contained"
              fullWidth
            >
              Télécharger NM Identity
            </Button>
          )}

          <Button className="normal" onClick={onLogout} variant="contained" fullWidth>Déconnexion</Button>
        </div>
      </Drawer>
    </div>
    </Box>
  </Box>
</Box>
  );
}

export default Header;
